<template>
    <div>
        <Header>
            <Heading1>{{ head.title }}</Heading1>
        </Header>
        <Content>
            <RenderBody :dataList="bodyData"></RenderBody>
        </Content>
    </div>
</template>
<script>
import Header from '../components/base/Header.vue';
import Heading1 from '../components/base/Heading1.vue';
import Paragraph from '../components/base/Paragraph.vue';
import Content from '../components/base/Content.vue';
import body from '~/content/privacy/data.json'
import RenderBody from '../components/base/RenderBody.vue';

export default {
    components: {
        Header,
        Heading1,
        Paragraph,
        Content,
        RenderBody
    },
    data: function () {
        return {
            head: {
                title: "Privacy policy",
                description: '`This privacy policy ("Policy") describes how the personally identifiable information ("Personal Information") you may provide on the macherusa.com website ("Website" or "Service") and any of its related products and services (collectively, "Services") is collected, protected and used.`'
            },
            bodyData: body
        };
    },
    head() {
        const { path = "" } = this.$route;

        const metaTitle = this.head.title + " | Macher Jobs";
        const metaDescription = this.head.description
        const canonical = process.env.baseUrl + path;

        return {
            title: metaTitle,
            link: [{ rel: "canonical", href: canonical }],
            meta: this.createMetaTags({
                description: metaDescription,
                title: metaTitle,
                canonical,
                socialTitle: metaTitle,
                socialDescription: metaDescription,
                siteName: "Macher Jobs",
                twitter: "@FrumJewishJobs",
            }),
        };
    },
};
</script>
